module.exports = __webpack_public_path__ + "img/mobilenewsLogo4.96f018cd.png";